import { ApplicationStep3 } from '../../../../../models/classes/ApplicationStep3.class'
import { StampDutyValuationEnum } from '../../../../../models/enum/stamp-duty-valuation.enum'
import ReviewPrivateSolicitor from '../../../../../pages/application-coo-stage-b/review-endorse/review-private-solicitor'
import { HoldingTypeTypeCode } from '../../../../../utils/code-converter'
import { Helpers } from '../../../../../utils/helper'
import { Stamp_Duty_Valuation } from '../../../../../utils/shared-radio'
import { TextInfo } from '../../../../text'
import {
  CONVEYANCING_ROW_TITLES,
  LegalDisplay,
  LOAN_ROW_TITLES,
  OwnerType,
  resolveLegalRepresentation,
} from './conveyancing-details.helper'
import './conveyancing-details.scss'
import { useMemo } from 'react'

interface ConveyancingDetailsProps {
  details: ApplicationStep3
}

const renderLegalDisplay = (display: LegalDisplay) => {
  switch (display.kind) {
    case 'hdb':
      return 'HDB Legal';
    case 'private':
      return (
        <div className='mt-2'>
          <ReviewPrivateSolicitor
            private_solicitor={display.solicitor}
            showCheckbox={display.showCheckbox ?? false}
          />
        </div>
      );
    case 'empty':
      return '-';
    case 'none':
      return undefined;
  }
};

const LegalRepresentationSection = ({
  details,
  ownerType,
}: {
  details: ApplicationStep3;
  ownerType: OwnerType;
}) => {
  const resolved = useMemo(
    () => resolveLegalRepresentation(details, ownerType),
    [details, ownerType]
  );

  return (
    <>
      {resolved.showLoanRow && (
        <TextInfo
          variant='column'
          title={LOAN_ROW_TITLES[ownerType]}
          description={renderLegalDisplay(resolved.loan)}
        />
      )}
      {resolved.showConveyancingRow && (
        <TextInfo
          variant='column'
          title={CONVEYANCING_ROW_TITLES[ownerType]}
          description={renderLegalDisplay(resolved.conveyancing)}
        />
      )}
    </>
  );
};

const ConveyancingDetails = ({ ...props }: ConveyancingDetailsProps) => {

  const proposedHoldingType = useMemo(() => {
    return HoldingTypeTypeCode.find(e=>e.code === props.details.holding_type! )?.description;
  }, [props.details.holding_type])

  const hasValuation = useMemo(() => {
    return !!props.details.valuation;
  }, [props.details.valuation])

  const isOwnOpinion = useMemo(() => {
    return props.details.valuation === StampDutyValuationEnum.own_opinion;
  }, [props.details.valuation])

  return (
    <div className='polymer-conveyancing-details'>
      <TextInfo variant='column' title={`Proposed Holding Type`} description={proposedHoldingType} />
      <TextInfo variant='column' title={`I confirm that all owners are willing and able to attend completion in person.`} description={props.details.attend_hdb_in_person ? "Yes" : "No"} />

      <LegalRepresentationSection details={props.details} ownerType="current" />
      <LegalRepresentationSection details={props.details} ownerType="proposed" />

      {hasValuation && <TextInfo variant='column' title={`Valuation options to determining the market value of the flat:`} description={Stamp_Duty_Valuation.find(e => e.value === props.details.valuation)?.description} />}
      {isOwnOpinion && <TextInfo variant='column' title={`Market value of the flat`} description={Helpers.formatThousandSeparator(props.details.estimated_market_value)} />}

    </div>
  )
}

export default ConveyancingDetails
